<template>
  <div
    class="overflow-visible position-relative"
    style="width: 200px; height: 200px;"
  >
    <!-- SVG Content Display -->
    <div
      v-if="compiledSvg && !selectedFile"
      v-html="compiledSvg"
      class="svg-container"
      style="width: 200px; height: 200px; display: flex; align-items: center; justify-content: center;"
    />
    
    <!-- Regular Image Display -->
    <v-img
      v-else
      :src="selectedFile ? selectedImage : image ? image : placeholderImage"
      alt="Avatar"
      width="200"
      height="200"
      class="rounded"
      :style="{ objectFit: 'contain' }"
    >
      <template v-slot:placeholder>
        <v-row
          class="fill-height ma-0"
          align="center"
          justify="center"
        >
          <v-progress-circular
            indeterminate
            color="grey lighten-5"
          ></v-progress-circular>
        </v-row>
      </template>
    </v-img>
    
    <v-btn
      color="primary"
      class="position-absolute"
      style="top: 10px;right:10px"
      fab
      dark
      x-small
      :loading="isSelectingPhoto"
      @click="onEditButtonClick"
      v-if="editable"
    >
      <v-icon>mdi-pencil</v-icon>
    </v-btn>
    <input
      ref="uploader"
      class="d-none"
      type="file"
      accept="image/*"
      @change="onFileChanged"
    />
  </div>
</template>
<script>
import axios from "axios";
export default {
  props: {
    image: {
      type: String
    },
    onImageSelected: {
      type: Function
    },
    editable: {
      type: Boolean,
      default: true
    },
    shadow: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      selectedFile: null,
      placeholderImage: require("../assets/placeholder.png"),
      isSelectingPhoto: false,
      selectedImage: null,
      compiledSvg: null
    };
  },
  methods: {
    onEditButtonClick() {
      this.isSelectingPhoto = true;
      window.addEventListener(
        "focus",
        () => {
          this.isSelectingPhoto = false;
        },
        { once: true }
      );
      this.$refs.uploader.click();
    },
    onFileChanged(e) {
      if (e.target.files.length != 0) {
        this.selectedFile = e.target.files[0];
        this.selectedImage = URL.createObjectURL(this.selectedFile);
        this.onImageSelected(this.selectedFile);
      }
    },
    loadSvgImage() {
      if (!this.image) {
        this.compiledSvg = null;
        return;
      }

      // Check if it's an SVG file
      const isSvg = this.image.toLowerCase().includes('.svg') || 
                   this.image.toLowerCase().includes('svg');
      
      if (isSvg) {
        console.log('Loading SVG:', this.image);
        axios({
          method: "get",
          url: this.image,
          headers: {
            'Accept': 'image/svg+xml, text/plain, */*'
          },
          timeout: 10000 // 10 second timeout
        })
          .then(result => {
            console.log('SVG loaded successfully:', result.data);
            // Ensure we have valid SVG content
            if (typeof result.data === 'string' && result.data.includes('<svg')) {
              this.compiledSvg = result.data;
            } else {
              console.warn('Invalid SVG content received');
              this.compiledSvg = null;
            }
          })
          .catch(error => {
            console.error("Error loading SVG file:", error);
            console.log("Falling back to img tag for:", this.image);
            this.compiledSvg = null;
          });
      } else {
        this.compiledSvg = null;
      }
    }
  },
  mounted() {
    this.loadSvgImage();
  },
  watch: {
    image(newValue) {
      console.log('Image changed:', newValue);
      this.selectedFile = null;
      this.selectedImage = null;
      this.compiledSvg = null;
      this.loadSvgImage();
    }
  },
};
</script>
<style scoped>
.svg-container {
  border-radius: 8px;
  overflow: hidden;
  background: #f5f5f5;
  border: 1px solid #e0e0e0;
}

.svg-container :deep(svg) {
  max-width: 100%;
  max-height: 100%;
  width: auto;
  height: auto;
}

.rounded {
  border-radius: 8px !important;
}
</style>
